import '@fontsource/montserrat/latin-400.css'
import '@fontsource/montserrat/latin-500.css'
import '@fontsource/montserrat/latin-600.css'
import '@fontsource/montserrat/latin-700.css'
import '@fontsource/montserrat-alternates/latin-700.css'
import { StrictMode } from 'react'
import { flushSync } from 'react-dom'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import { preloadPage } from './routes/pages'

/**
 * Páginas públicas chegam pré-renderizadas pelo build (scripts/prerender.mjs), com o texto já
 * no HTML para buscadores. Aqui o React renderiza a página por cima, do mesmo jeito que sem
 * pré-renderização: baixamos antes o código da página atual para trocar o conteúdo de uma vez,
 * sem piscar o carregamento, e depois removemos o CSS e as tags de <head> do build.
 */
function removePrerenderArtifacts() {
  document.querySelectorAll('[data-pv-prerender], [data-pv-head]').forEach((element) => element.remove())
  document.documentElement.removeAttribute('data-pv-spa')
}

const container = document.getElementById('root')!

preloadPage(window.location.pathname)
  .catch(() => undefined)
  .finally(() => {
    const root = createRoot(container)
    flushSync(() => {
      root.render(
        <StrictMode>
          <App />
        </StrictMode>,
      )
    })
    removePrerenderArtifacts()
  })
